import * as React from 'react';
import * as style from './style.css';

interface IGkCardLayoutProps {
  onHover(hovered: boolean): void;
}

export const GkCardLayout: React.FC<React.PropsWithChildren<IGkCardLayoutProps>> = ({ children, onHover }) => {
  const handleMouseEnter = React.useCallback(() => {
    onHover(true);
  }, [onHover]);

  const handleMouseLeave = React.useCallback(() => {
    onHover(false);
  }, [onHover]);

  return (
    <div
      data-name="GKCardComponent"
      className={style['layout']}
      data-testid="GKCard"
      data-mark="GKCard"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};
